import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import Media from './components/Media';
import Contact from './components/Contact';
import Ranking from './components/Ranking';
import AppSection from './components/AppSection';
import Updates from './components/Updates';
import Features from './components/Features';
import IndexSection from './components/IndexSection';
import Cards from './components/Cards';
import Topics from './components/Topics';
import About from './components/About';
import Faq from './components/Faq';
import Carousel from './components/Carousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Comments />
        <Media />
        <Contact />
        <Ranking />
        <AppSection />
        <Updates />
        <Features />
        <IndexSection />
        <Cards />
        <Topics />
        <About />
        <Faq />
        <Carousel />
      </main>
      <Footer />
    </>
  );
}